<script>
    import PasswordSetter from '../../components/PasswordSetter.svelte';
    import Spinner from '../../components/Spinner.svelte';
	import UnathContext from '../../layouts/UnathContext.svelte';
	import { navigate } from 'svelte-routing';
	import queryString from 'query-string';
	import firebase from '../../firebase';
    import functions from '../../functions';
    import { currentUser } from '../../stores/currentUser';
    import * as regex from '../../util/regex';

	const params = queryString.parse(window.location.search);
    let email = params.email || '';
    let name = '';
    let password = '';
    
    $: isValidEmail = email.match(regex.email);
    let isValidPassword;
    
    let errorMessage;
    let signUpPromise;

	const signUp = async () => {
        signUpPromise = (async () => {
            if (!isValidEmail) throw { message: 'Email is not valid.' };
            if (!isValidPassword) throw { message: 'Password is not valid.' };
            const { user } = await firebase.auth().createUserWithEmailAndPassword(email, password);
            await functions.post(`userData/${user.uid}`, { email, name }, { user });
            await user.sendEmailVerification();
            navigate('/auth/sign-up-successful');
        })().catch(error => errorMessage = error.message);
    }
</script>

<UnathContext title="Sign up" on:enterPressed={signUp}>
    <div class="modal">
        <div class="modal__box modal__box--md">
            <div class="modal__header">
                Sign up to Eastwood 45
            </div>
            <div class="modal__body layout">
                <div class="layout__column">
                    <div class="layout__item">
                        <input class="form__input" type="text" placeholder="Name" bind:value={name} />
                    </div>
                    <div class="layout__item">
                        <input class="form__input {!isValidEmail ? 'form__input--invalid' : ''}" type="text" placeholder="Email" bind:value={email} />
                    </div>
                    <PasswordSetter bind:password={password} bind:isValid={isValidPassword} />
                    {#if errorMessage}
                        <div class="layout__item error-message">{errorMessage}</div>
                    {/if}
					<div class="layout__row layout__row--collapsable layout__row--space-between">
						<div class="layout__item">
							<div
								class="form__button form__button--subtle"
								on:click={() => navigate(`/auth/sign-in${email ? `?email=${encodeURIComponent(email)}` : ""}`)}>
                                Back to sign in
							</div>
						</div>
						<div class="layout__row layout__row--right">
							<div class="layout__item">
								{#await signUpPromise}
                                    <div class="form__button form__button--disabled"><Spinner />Sign up</div>
                                {:then result}
                                    <div class="form__button" on:click={signUp}>Sign up</div>
                                {/await}
							</div>
						</div>
					</div>
                </div>
            </div>
        </div>
    </div>
</UnathContext>